import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { sumTotal, totalRowRatio } from '../../../../../react-table/helpers/rowTotals';

export const getCarrierTabNavigationProps = carrierData => rowInfo => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.CARDIT_NESTING_LOCATION_801.id,
    mainReportId: ReportDefinitions.CARDIT_NESTING_OPERATOR_801.id,
    requestParams: {
      postalOperator: rowInfo.row.postalOperator,
      carriers: carrierData.carriers,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
    reportsToBeCleared: [
      ReportDefinitions.CARDIT_NESTING_DETAILS_801.id,
    ],
  } : {}
);

export default (data, carrierData) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NavigationWithFooterColumn,
    PercentageColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Postal operator', 'postalOperator').withTotalHeader('Total', 'bg-total-darkGrey'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NavigationWithFooterColumn(new NonZeroNumberColumn('Total', 'receptacles.total').withTotalHeader(sumTotal, 'bg-total-darkGrey'), getCarrierTabNavigationProps(carrierData)),
        new NonZeroNumberColumn('CJID nested', 'receptacles.cjidNested').withShow(false),
        new NonZeroNumberColumn('ULD ID nested', 'receptacles.uldIdNested').withShow(false),
        new PercentageColumn('% CJID nested', 'receptacles.pctCjidNested').withTotalHeader(totalRowRatio(['receptacles.cjidNested', 'receptacles.total']), 'bg-total-darkGrey'),
        new PercentageColumn('% ULD ID nested', 'receptacles.pctUldIdNested').withTotalHeader(totalRowRatio(['receptacles.uldIdNested', 'receptacles.total']), 'bg-total-darkGrey'),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.CARDIT_NESTING_LOCATION_801.id,
        mainReportId: ReportDefinitions.CARDIT_NESTING_OPERATOR_801.id,
        requestParams: {
          isTotal: true,
          postalOperator: '*',
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
